export default __webpack_public_path__ + "static/media/bn.js.a7c76563.map";